import { isEqual } from "lodash-es";
import { InputHTMLAttributes, useEffect } from "react";
import { useController, useFormContext } from "react-hook-form";
import { usePrefixedFieldName } from "shared/components/form/FormFieldPrefix";

export interface FormHiddenInputProps
  extends Omit<InputHTMLAttributes<unknown>, "name" | "value"> {
  name: string;
  value?: string | string[];
  shouldUnregister?: boolean;
}

export const FormHiddenInput: React.FC<FormHiddenInputProps> = ({
  name,
  value,
  defaultValue,
  shouldUnregister,
  ...props
}) => {
  const prefixedName = usePrefixedFieldName(name);
  const { setValue, control } = useFormContext();
  const { field } = useController({
    control,
    name: prefixedName,
    defaultValue: defaultValue ?? value,
    shouldUnregister,
  });

  useEffect(() => {
    if (value !== undefined && !isEqual(field.value, value)) {
      setValue(prefixedName, value);
    }
  }, [setValue, value, prefixedName, field.value]);

  return <input type="hidden" {...field} {...props} />;
};
